import { Card, CardBody, Col } from "reactstrap";
import { invoicesCard, monthlyDropdownList } from "../../../../../Data/DashboardsData/ECommerceData";
import { TotalEarningCardProp } from "../../../../../Types/DashboardsType";
import { InvoicesTitle } from "../../../../Constants";
import DropdownWithHeader from "../../DropdownWithHeader";
import ReactApexChart from "react-apexcharts";

export default function InvoicesCard({ colClass }: TotalEarningCardProp) {
  return (
    <Col xl={12} className={colClass}>
      <Card className="invoices">
        <DropdownWithHeader headerClass="pb-0" heading={InvoicesTitle} dropDownList={monthlyDropdownList} dropDownClass="icon-dropdown" dropDownIcon={true} />
        <CardBody>
          <div id="client">
            <ReactApexChart options={invoicesCard} series={invoicesCard.series} type="line" height={70} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
